const PreviewPage = () => import('../views/PreviewQuizPage');
const PreviewVideoPage = () => import('../views/PreviewVideoPage');

const router = [
  {
    path: '/admin-viewer/cards/:cardId(\\d+)/pages/:pagePosition(\\d+)',
    component: PreviewPage,
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/viewer/page/:id(\\d+)',
    component: PreviewPage,
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/viewer/video-lecture/:id(\\d+)',
    component: PreviewVideoPage,
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
];

export default router;
